export const formatAge = (days, neverAudited = false) => {
  const parsed = Number(days)
  if (!Number.isFinite(parsed)) return '—'
  const rounded = Math.round(parsed)
  return neverAudited ? `${rounded}d since contract` : `${rounded}d since audit`
}

export const formatDistance = miles => {
  const parsed = Number(miles)
  return Number.isFinite(parsed) ? `${parsed.toFixed(1)} mi` : '—'
}

export const formatScore = score => {
  const parsed = Number(score)
  return Number.isFinite(parsed) ? parsed.toFixed(1) : '—'
}

export const formatPercent = value => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? `${Math.round(parsed * 100)}%` : '—'
}

export const formatActivityAction = activity => {
  if (activity?.type === 'audit') {
    const action = activity.status === 'completed'
      ? 'completed'
      : activity.status === 'open'
        ? 'open'
        : 'submitted'
    return `${activity.auditName || 'Integrated Audit'} ${action}`
  }
  const labels = {
    priority_changed: 'Priority adjusted',
    excluded: 'Removed from queue',
    restored: 'Restored to queue',
    deferred: 'Deferred',
    defer_cleared: 'Deferral cleared'
  }
  return labels[activity?.action] || 'Queue updated'
}

export const filterQueueStops = (stops = [], search = '') => {
  const terms = String(search || '').trim().toLowerCase().split(/\s+/).filter(Boolean)
  if (!terms.length) return stops
  return stops.filter(stop => {
    const searchText = [
      stop.name,
      stop.address,
      stop.aspirePropertyId,
      ...(stop.reasons || []),
      ...(stop.dataQuality || [])
    ].filter(value => value !== null && value !== undefined).join(' ').toLowerCase()
    return terms.every(term => searchText.includes(term))
  })
}
